<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import {h} from "vue";

export default {
  name: 'legoStepBox',
  mixins: [i18nMixin],
  emits: [
    'moveStep',
    'action',
    'cancel'
  ],
  props: {
    steps: {type: Array, default: () => []},
    stepWidth: {type: [String, Number], default: 170},
    fullHeight: {type: Boolean, default: false},
    actionText: {type: String, default: ''},
    previousText: {type: String, default: ''},
    nextText: {type: String, default: ''},
    cancelText: {type: String, default: ''},
    stepsCheck: {type: Boolean, default: false},
  },
  data() {
    return {};
  },
  methods: {
    buildStepperItem(idx) {
      // 0. prepare
      // let $ce = this.$createElement,
      let itemChs = [];
      let childOn = {
        click: () => {
          if (this.currIdx > idx) this.setIdx(idx);
        },
      };
      // 1. item option
      let itemClazz = 'lego-step-box__stepper__item ' + itemClassByState(this.stateList[idx]);
      // 2. item stat(bubble)
      let statCont = null;
      switch (this.stateList[idx]) {
        case 'D':
          statCont = h('lego-icon', {}, ['check']);
          break;
        case 'F':
          statCont = h('lego-icon', {}, ['close']);
          break;
        default:
          statCont = h('span', {}, [idx + 1]);
      }
      itemChs.push(
          h('div', {class: 'lego-step-box__stepper__item__stat', on: childOn}, [statCont]),
      );
      // 3. stat label
      let step = this.steps[idx];
      let label = typeof step === 'object' ? step.name : step;
      itemChs.push(
          h('div', {class: 'lego-step-box__stepper__item__label', on: childOn}, [label]),
      );
      // x. return "STEPPER ITEM"

      return h('div', {class: itemClazz, style: {width: this.$_stepWidth + 'px'}}, itemChs);

      // -. local function
      function itemClassByState(stat) {
        switch (stat) {
          case 'D':
            return 'lego-step-box__stepper__item--done';
          case 'F':
            return 'lego-step-box__stepper__item--fail';
          case 'I':
            return 'lego-step-box__stepper__item--ing';
          case 'R':
            return 'lego-step-box__stepper__item--ready';
          default:
            return 'lego-step-box__stepper__item--fail';
        }
      }
    },
    setIdx(idx) {
      // 1. check valid
      let ci = this.currIdx;
      if (idx > ci) {
        // move to forward
        // 1.1 current step
        let cstep = this.steps[ci];
        if (typeof cstep === 'object' && !cstep.valid) {
          this.$notify({text: 'Check step valid condition.', type: 'warn'});
          return;
        }

        let fn = () => true;
        if (cstep && cstep.check && typeof cstep.check === 'function') fn = cstep.check;
        if (fn() !== true) return;

        // 1.2 iter step
        for (let i = ci + 1, ii = this.steps.length; i < ii && i < idx; i++) {
          let step = this.steps[i];
          if (typeof step === 'object' && !step.valid) {
            this.$notify({
              text: 'Check step valid condition in step ' + (i + 1) + '.',
              type: 'warn',
            });
            idx = i;
            break;
          }
        }
      }
      // 2. set value
      // 2.1 set State List
      for (let i = 0, ii = this.stateList.length; i < ii; i++) {
        this.stateList[i] = i < idx ? 'D' : 'R';
      }

      if (this.stepsCheck) {
        this.$emit('moveStep', idx, val => {
          if (val) {
            this.stateList[idx] = 'I';
            this.currIdx = idx;
            this.$forceUpdate();
          }
        });
      } else {
        this.stateList[idx] = 'I';
        this.currIdx = idx;
        this.$forceUpdate();
        this.$emit('moveStep', idx);
      }
    },
    buildActions() {
      // let $ce = this.$createElement;
      let ci = this.currIdx,
          step = this.steps[ci];
      let valid = typeof step === 'object' ? step.valid : true;
      let chs = [];
      // 1. add button
      // 1.1 first step
      // 임시 취소 사용안함
      if (ci === 0 || ci > 0) {
        let opt = {};
        opt.on = {
          click: () => {
            this.$emit('cancel', ci);
          },
        };
        opt.attrs = {large: true};
        chs.push(h('lego-button', opt, this.cancelText || this.t('button.cancel')));
      }
      // 1.1 previous step
      if (ci > 0) {
        let opt = {};
        opt.on = {
          click: () => {
            this.setIdx(ci - 1);
          },
        };
        opt.attrs = {large: true, primary: true, border: true};
        chs.push(h('lego-button', opt, this.previousText || this.t('button.previous')));
      }
      // 1.2 Next step
      if (ci < this.steps.length - 1) {
        let opt = {};
        opt.on = {
          click: () => {
            this.setIdx(ci + 1);
          },
        };
        opt.props = {disabled: !valid};
        opt.attrs = {large: true, primary: true, solid: true};
        chs.push(h('lego-button', opt, this.nextText || this.t('button.next')));
      }
      // 1.3 last action
      if (ci === this.steps.length - 1) {
        let opt = {};
        opt.props = {primary: true, solid: true, large: true};
        opt.on = {
          click: () => {
            this.$emit('action', ci);
          },
        };
        opt.attrs = {large: true};
        chs.push(h('lego-button', opt, this.actionText || this.t('button.action')));
      }
      return h('lego-action-bar', {}, chs);
    },
  },
};
</script>
<style lang="scss" scoped>
.lego-step-box__stepper {
  align-items: flex-start;
  background-color: $color--ui12;
  padding: 20px;
  border: 0;
  position: relative;
  height: 88px;

  &__spacing {
    top: 10px;
    left: 0;
    width: 12px;
    color: transparent;
    position: relative;

    &:after {
      content: '';
      display: block;
      width: 126px;
      height: 1px;
      background-color: $color--ui07;
      left: calc(-100% - 46px);
      top: 2px;
      position: absolute;
    }
  }

  &__item {
    justify-content: center;
    flex: 0 0 170px;

    &__stat {
      width: 24px;
      height: 24px;
      flex: 0 0 24px;
      background-color: $color--ui07;
      border-color: $color--ui07;
      cursor: default;

      span {
        color: $color--ui-white;
        @include font(14px, 500);
      }
    }

    &--ready {
      .lego-step-box__stepper__item__stat {
        background-color: $color--ui07;
        border-color: $color--ui07;
      }

      + .lego-step-box__stepper__spacing {
        &:after {
          background-color: $color--ui08;
        }
      }
    }

    &--ing {
      .lego-step-box__stepper__item__stat {
        background-color: $color--primary;
        border-color: $color--primary;
      }
    }

    &--done {
      .lego-step-box__stepper__item__stat,
      .lego-step-box__stepper__item__label {
        cursor: pointer;
      }

      .lego-step-box__stepper__item__stat {
        border-color: $color--primary;

        :deep .lego-icon {
          color: $color--primary;
        }
      }

      + .lego-step-box__stepper__spacing {
        &:after {
          background-color: $color--primary;
        }
      }
    }

    &__label {
      @include font(14px);
      font-weight: 500 !important;
      width: 100%;
      margin-top: 5px;
      text-align: center;
      word-break: keep-all;
      word-wrap: break-word;
      cursor: default;
    }
  }
}

.lego-step-item {
  margin: 32px 0 24px 0;

  & + .lego-action-bar {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $color--ui07;
    text-align: right;
  }
}
</style>
